import { match } from '@/utils/pattern-match-util'
import type { BookkeepingPlatform } from './bookkeeping-platform'
import type { BookkeepingPlatformConnection } from './BookkeepingPlatformConnection'

export function formatBookkeepingPlatform(
  bookkeepingPlatform: BookkeepingPlatform,
) {
  return match(bookkeepingPlatform, {
    Xero: 'Xero',
    QuickBooks: 'QuickBooks',
    Other: 'Other',
  })
}

/**
 * Formats the bookkeeping platform as it is named on its own login page.
 */
export function formatBookkeepingPlatformLoginName(
  bookkeepingPlatform: BookkeepingPlatform,
) {
  return match(bookkeepingPlatform, {
    Xero: 'Xero',
    QuickBooks: 'QuickBooks Online',
    Other: 'Other',
  })
}

export function getBookkeepingPlatformLoginUrl(
  bookkeepingPlatform: BookkeepingPlatform,
) {
  return match(bookkeepingPlatform, {
    Xero: 'https://login.xero.com/identity/user/login',
    QuickBooks: 'https://accounts.intuit.com/app/sign-in',
    Other: null,
  })
}

/**
 * Formats the instructions for giving the Pro access through the connection.
 */
export function formatBookkeepingPlatformConnectionHelpText(
  connection: BookkeepingPlatformConnection,
) {
  return match(connection.type, {
    QuickBooks:
      'Log into QuickBooks and give the Pro access to the client’s books. Then, click the "Confirm Access" button below to complete the connection.',
    Xero: 'Log into Xero and give the Pro access to the client’s books. Then, click the "Confirm Access" button below to complete the connection.',
    Other:
      'Based on the respective software, instruct the client to give the Pro access to their books. Then, click the "Confirm Access" button below to complete the connection.',
  })
}
